import { useQuery } from "react-query";
import axios from "axios";
const useAllCatergories = () => {
  return useQuery("allCategories", () =>
    axios.get("https://ecommerce.routemisr.com/api/v1/categories")
  );
};
export default useAllCatergories;
